import { jsx } from "react/jsx-runtime";
import { Box, Badge } from "braid-design-system";
import { cursorPointer } from "./TabBadge.css.mjs";
const TabBadge = (props) => /* @__PURE__ */ jsx(Box, { className: cursorPointer, children: /* @__PURE__ */ jsx(Badge, { ...props }) });
export {
  TabBadge
};
